import React from 'react';
import { useVendors } from '../hooks/useVendors';
import { useWebsiteContent } from '../hooks/useWebsiteContent';
import { trackVendorClick } from '../utils/analytics';
import SEO from '../components/SEO';
import './Vendors.css';

const Vendors = () => {
  const { vendors, loading, error } = useVendors();
  const { content } = useWebsiteContent('vendors');

  // Handle vendor click tracking
  const handleVendorClick = (vendor, index) => {
    trackVendorClick(vendor.name, vendor.url, index + 1);
  };

  if (loading) {
    return (
      <div className="vendors">
        <SEO
          title="Vendrs - MarketVendr Distribution Partners"
          description="Discover MarketVendr's trusted vendor partners and their exceptional products. Browse our network of UK distribution partners."
          keywords="MarketVendr vendors, UK distribution partners, vendor network, trusted suppliers UK"
          url="https://www.marketvendr.com/vendrs"
        />
        <section className="vendors-hero">
          <div className="container">
            <h1>{content.vendors_title || 'Vendrs'}</h1>
            <p>{content.vendors_subtitle || 'Discover our trusted partners and their exceptional products'}</p>
          </div>
        </section>
        <section className="vendors-content">
          <div className="container">
            <p>Loading vendors...</p>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div className="vendors">
        <SEO
          title="Vendrs - MarketVendr Distribution Partners"
          description="Discover MarketVendr's trusted vendor partners and their exceptional products. Browse our network of UK distribution partners."
          keywords="MarketVendr vendors, UK distribution partners, vendor network, trusted suppliers UK"
          url="https://www.marketvendr.com/vendrs"
        />
        <section className="vendors-hero">
          <div className="container">
            <h1>{content.vendors_title || 'Vendrs'}</h1>
            <p>{content.vendors_subtitle || 'Discover our trusted partners and their exceptional products'}</p>
          </div>
        </section>
        <section className="vendors-content">
          <div className="container">
            <p>Error loading vendors. Please try again later.</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="vendors">
      <SEO
        title="Vendrs - MarketVendr Distribution Partners"
        description="Discover MarketVendr's trusted vendor partners and their exceptional products. Browse our network of UK distribution partners helping international businesses import products to the UK."
        keywords="MarketVendr vendors, UK distribution partners, vendor network, trusted suppliers UK, UK import partners, UK distribution network"
        url="https://www.marketvendr.com/vendrs"
      />
      <section className="vendors-hero">
        <div className="container">
          <h1>{content.vendors_title || 'Vendrs'}</h1>
          <p>{content.vendors_subtitle || 'Discover our trusted partners and their exceptional products'}</p>
        </div>
      </section>

      <section className="vendors-content">
        <div className="container">
          {vendors.length === 0 ? (
            <div className="no-vendors">
              <p>No vendors available at the moment.</p>
            </div>
          ) : (
            <div className="vendors-grid">
              {vendors.map((vendor, index) => {
                const CardContent = (
                  <>
                    <div className="vendor-image-placeholder">
                      {vendor.image_url ? (
                        <img src={vendor.image_url} alt={vendor.name} />
                      ) : (
                        <div className="vendor-placeholder">
                          <span>{vendor.name.charAt(0)}</span>
                        </div>
                      )}
                    </div>
                    <h3>{vendor.name}</h3>
                  </>
                );

                return vendor.url ? (
                  <a
                    key={vendor.id}
                    href={vendor.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="vendor-card vendor-card-link"
                    onClick={() => handleVendorClick(vendor, index)}
                  >
                    {CardContent}
                  </a>
                ) : (
                  <div key={vendor.id} className="vendor-card">
                    {CardContent}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Vendors;

